import * as React from 'react'
import Logo from "../Assets/Logo2020OK.png"
import { useHistory } from "react-router-dom"

//This component display the Header part of the application. It routes User clicking on Title or Subtitle
export const Header: React.FunctionComponent = (props) => {
    let history = useHistory()

    const returnToHome = () => {
        window.location.href = 'https://en-deuil-et.com'
    }

    const returnToTrainings = () => {
        history.push('/')
    }


    return(
        <div>
            <div className="HeaderFlex">
                <h1 className="HeaderTitle" onClick={()=>{returnToHome()}}>EN DEUIL ET...</h1>
                <div className="HeaderSubtitle" onClick={()=>{returnToTrainings()}} >Plateforme de <span className="HeaderSubtitleE">E</span>-Formation</div>
                <img className="HeaderLogo" src={Logo} alt="logo"></img>
            </div>
        </div>
    )
}